import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import { AlertManagementPort, CreateAlertData, UpdateAlertData, DeleteAlertData } from '../../domain/ports/AlertManagementPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseAlertManagementAdapter implements AlertManagementPort {
  private readonly prefix = 'alerts';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async createAlert(data: CreateAlertData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-createAlert`;
    this.logger.logRepositoryRequest('AlertManagementAdapter', 'createAlert', { functionName, data });
    
    try {
      const createAlertFn = httpsCallable(functions, functionName);
      const result = await createAlertFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('AlertManagementAdapter', 'createAlert', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('AlertManagementAdapter', 'createAlert', duration, error);
      console.error('Create alert error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async updateAlert(data: UpdateAlertData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateAlert`;
    this.logger.logRepositoryRequest('AlertManagementAdapter', 'updateAlert', { functionName, data });
    
    try {
      const updateAlertFn = httpsCallable(functions, functionName);
      const result = await updateAlertFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('AlertManagementAdapter', 'updateAlert', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('AlertManagementAdapter', 'updateAlert', duration, error);
      console.error('Update alert error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }

  async deleteAlert(data: DeleteAlertData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-deleteAlert`;
    this.logger.logRepositoryRequest('AlertManagementAdapter', 'deleteAlert', { functionName, data });
    
    try {
      const deleteAlertFn = httpsCallable(functions, functionName);
      const result = await deleteAlertFn(data);
      
      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('AlertManagementAdapter', 'deleteAlert', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('AlertManagementAdapter', 'deleteAlert', duration, error);
      console.error('Delete alert error:', error);
      
      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }
      
      throw RepositoryError.queryFailed();
    }
  }
}